<template>
               <div >
              
                            <h1>我的帳戶</h1><!--目前所在頁面標題-->
                            <section class="panel">
                                <div class="avatarWrapper cf">
                                    <div class="avatar">
                                        <div class="photo">
                                            <img :src="userInfo.avatar">
                                        </div>
                                        <!--上傳功能-->
                                        <div class="avatarPicker">
                                            <input class="inputfile" title="上傳照片" type="file" id="profile_pic" name="profile_pic" accept=".jpg, .jpeg, .png">
                                            <label for="profile_pic">Choose a file</label>
                                        </div>
                                        <!--上傳功能 end-->
                                    </div>
                                    <div class="info">
                                        <div class="wrap">
                                            <strong>{{userInfo.nickname}}</strong>
                                                          <p>								<b class="others" v-if="userInfo.type == 1">FB</b>
						<b class="others" v-if="userInfo.type == 2">Google</b>
						<b class="others" v-if="userInfo.type == 3">Phone</b>
						<b class="others" v-if="userInfo.type == 4">UDN</b>
						<b class="others" v-if="userInfo.type == 5">Device</b>
                        登入
                        </p>
                                        </div>
                                    </div>
                                </div>
                                <div class="wallet cf">
                                    <h3>錢包餘額</h3>
                                    <strong>{{userInfo.points}}點</strong>
                                </div>
                            </section>
                            <section class="panel userSetting">
                                <h2>個人資料</h2>
                                <label for="nickname" class="inp"><!--如果輸入錯誤 新增class "error"-->
                                    <input type="text" id="nickname" placeholder="&nbsp;" :value="userInfo.nickname">
                                    <span class="label">暱稱</span>
                                    <span class="border"></span>
                                    <span class="errorText">此電子信箱不存在</span><!--輸入錯誤時出現-->
                                </label>
                                <div class="list_info">
                                    <h4>ID</h4>
                                    <p>{{userInfo.account}}</p>
                                </div>
                                <button type="submit" class="btnStyle_2" id="submit_login_udn">
                                    <span data-original-title="儲存">儲存</span>
                                </button>
                            </section>
                            <button @click="signOut" type="submit" class="btnStyle_2 colorWhite" id="submit_login_udn">
                                <span data-original-title="登出">登出</span>
                            </button>
                        </div>
</template>

<script>
import * as firebase from "firebase";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods:{
          signOut() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$store.dispatch("authLogout").then(() => {
            this.$router.push("/");
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/mySubviews/MyProfile.vue